// extracted by mini-css-extract-plugin
export default {"navButton":"navButton_navButton__O2KFS"};